import React from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { RouteComponentProps } from 'react-router';
import { IStore } from 'reducers/index';
import { fetchBookingDetails } from 'actions/bookings';
import { fetchNftpBillable } from 'actions/exportJob';
import { IBookingDetails } from 'reducers/bookings/models';
import { ErrorDialog } from 'components/error-dialog';
import { PageHeader } from 'components/page-header';
import { BookingDetailsTopBar } from './BookingDetailsTopBar';
import API from 'constants/api';
import { calculateTotalOfField, findAllinArr, generateDistributionData } from '../../utils/CostAndRevenueHelpers';
import { CostAndRevenue } from 'modules/cost-revenue/component/CostAndRevenue';
import { IMaterialList } from 'reducers/materialMaster';
import { TabComponent } from 'components/sub-navigation/components/TabComponent';
import { navLinksBooking, fcrCols, cblCols, equipmentCols, clrCols } from 'constants/tableConstants';
import BookingDetails from './BookingDetails';
import { formatValueIfNullOrUndefined, clearFormat, formatDate, isFeatureEnabled } from 'utilities/util';
import CostColumnsData from 'views/job-costing/utils/CostColumnsData';
import { HeaderWrapper } from 'components/cost-revenue/HeaderWrapper';
import InPageDialog from '../../../../components/page-dialog';
import { Partners } from 'modules/partners/Partners';
import { HistoryLog } from 'modules/history/HistoryLog';
import * as ValidationMessages from 'constants/validationMessages';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { localCurrency } from 'constants/customs';
import { fetchCostAndRevenue } from 'actions/costRevenue';
import { IResponse } from 'reducers/bookings/models';
import { targetFunctionality } from 'constants/targetFunctionality';
import { isNftpRoeEnabled, calculateActualTotal } from 'utilities/nftp';

interface IParams {
    bookingId: string;
}
interface IMapDispatchToProps {
    fetchBookingDetails: (bookingId: number) => Promise<void>;
    fetchCostAndRevenue: (type: number, valueId: any[], targetType: string) => Promise<void>;
    fetchNftpBillable: (jobId: number) => Promise<void>;
}

interface IMapStateToProps {
    bookingDetails: IBookingDetails;
    fetchError: string | string[],
    isFetchDataLoading: boolean;
    isFetchDataError: boolean;
    isFetchDataPendingError: string | string[],
    materialMasterList: IMaterialList[];
    featureToggles: IFeatureToggleModel[];
    costAndrevenueresponse: IResponse;
    isNftpBillable: boolean | undefined;
    isNftpBillableLoading: boolean;
}

interface IBookingsCharges extends RouteComponentProps<IParams>, IMapDispatchToProps, IMapStateToProps { }
interface IState {
    activeTab: number,
    disableTab: boolean,
    hasError: boolean,
    totalRevenue: string,
    totalCost: string,
    showDialog: boolean,
    pendingError: string,
    status: string[],
    isActionHidden: boolean;
    isNftpRoeEnabled?: boolean;
    isNftpRoeEnabledLoading?: boolean;
    actualRevenue?: string;
    actualCost?: string;
}
export class _ChargesBookingDetails extends React.Component<IBookingsCharges, IState> {
    constructor(props: IBookingsCharges) {
        super(props);
        this.state = this.initialState();
    }
    public componentDidMount() {
        this.props.fetchBookingDetails(Number(this.props.match.params.bookingId));
        this.props.fetchCostAndRevenue(1, [Number(this.props.match.params.bookingId)], 'origin');
    }
    public componentWillUnmount() {
        this.initialState();
    }
    public initialState = (): IState => {
        return {
            activeTab: 0,
            disableTab: false,
            showDialog: false,
            totalRevenue: '0',
            totalCost: '0',
            pendingError: '',
            status: [],
            hasError: false,
            isActionHidden: false,
            isNftpRoeEnabled: false,
            isNftpRoeEnabledLoading: true,
            actualRevenue: '0',
            actualCost: '0',
        };
    };
    public async componentDidUpdate(props: any) {
        if (this.props.bookingDetails !== props.bookingDetails) {

            const firstJob = this.props.bookingDetails.documents
                ?.find((doc: any) => doc.finNumber?.startsWith('FI'));

            if (firstJob && isFeatureEnabled(FEATURE_TOGGLES.FINOPS_NFTP_SALESORDER_REQ_EXPORT, this.props.featureToggles)) {
                await this.props.fetchNftpBillable(Number(firstJob.exportJobId));
            }
            this.setState({ isNftpRoeEnabled: isNftpRoeEnabled(this.props.isNftpBillable ?? false, this.props.featureToggles) });
            this.setState({ isNftpRoeEnabledLoading: false});
            this.getActualTotal();
            const handleError = (error: any[]): boolean => {
                const errList: string[] = [];
                this.props.bookingDetails.documents.forEach((child: any) => {
                    if (child.rateErrorMessage && child.rateErrorMessage !== '-') {
                        errList.push(child.rateErrorMessage);
                    }
                });
                if (error && errList && errList.length > 0) {
                    this.setState({ showDialog: true, pendingError: errList.toString().replace(/\|/g, '\n') });
                    return true;
                }
                return false;
            };

            const status: string[] = findAllinArr(this.props.bookingDetails.documents, 'finOpsStatus');
            const hasError: boolean = this.props.bookingDetails && this.props.bookingDetails.documents ? handleError(this.props.bookingDetails.documents) : false;
            this.setState({
                status,
                hasError
            });
        }
    }

    public getActualTotal = () => {
        const rateDetailsList = this.props.costAndrevenueresponse.result[0]?.essoRateDetailsModels || [];
        const actualRevenue = calculateActualTotal(rateDetailsList, CostColumnsData.TYPES.REVENUE);
        const actualCost = calculateActualTotal(rateDetailsList, CostColumnsData.TYPES.COST);
        this.setState({ actualRevenue, actualCost }) ;
    };
    public getExportJobIdDetails() {
        const exportDocuments = this.props.bookingDetails.documents.filter(
            (doc) => doc.finNumber
        );
        return exportDocuments.map((doc, index) => (
            <span key={index}>
                <a
                    onClick={() =>
                        this.props.history.push(`/job-costing/exportjobs/${doc.exportJobId}`)
                    }
                >
                    {doc.finNumber}
                </a>
                {index < exportDocuments.length - 1 && ', '}
            </span>
        ));
    }

    public getImportJobIdDetails() {
        const importDocuments = this.props.bookingDetails.equipmentTransportShipments.filter(
            (doc) => doc.id || doc.equipmentTransportShipmentDocumentNumber
        );
        return importDocuments.map((doc, index) => (
            <span key={index}>
                <a
                    onClick={() =>
                        this.props.history.push(`/job-costing/ets/${doc.id}`)
                    }
                >
                    {doc.equipmentTransportShipmentDocumentNumber || doc.id}
                </a>
                {index < importDocuments.length - 1 && ', '}
            </span>
        ));
    }

    public render() {
        const isExtraDocumentFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.EXTRA_DOCUMENT, this.props.featureToggles);
        const isHblConsumptionEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_HBL_CONSUMPTION, this.props.featureToggles);
        return (
            <React.Fragment>
                <ErrorDialog endpoint={API.Booking.BookingDetails} />
                <PageHeader backButton={true}
                    displayConfirm={this.state.disableTab}
                    confirmMessage={this.state.disableTab ? ValidationMessages.CostAndRevenue.Alert_Page_Exit : ''}
                    id="booking-details">Booking Number: {this.props.bookingDetails.booking.bookingNumber}</PageHeader>
                {this.state.showDialog && <div className={'padding-bottom-large padding-left-large padding-right-large'}><InPageDialog
                    showDialog={this.state.showDialog}
                    type={'error'}
                    message={this.state.pendingError}
                    closeMethod={() => this.setState({ showDialog: false })} /></div>}
                <HeaderWrapper
                    firstValue={this.props.bookingDetails.booking.status}
                    secondValue={this.props.bookingDetails.documents && this.props.bookingDetails.documents.length >= 1 && this.props.bookingDetails.documents[0].finOpsStatus ? this.props.bookingDetails.documents[0].finOpsStatus : undefined}
                    thirdValue={this.props.bookingDetails.booking.incoterm}
                    forthValue={formatDate(this.props.bookingDetails.booking.updateDate)}
                    statusColor={this.state.hasError ? 'red' : ''}
                    target={1}
                    totals={{
                        firstRow: { label: 'Total Revenue', value: this.state.totalRevenue, actualValue: this.state.actualRevenue },
                        secondRow: { label: 'Total Cost', value: this.state.totalCost, actualValue: this.state.actualCost },
                        lastRow: { label: 'Profitability' },
                        isNftpRoeEnabled: this.state.isNftpRoeEnabled
                    }}
                />
                {this.props.bookingDetails.documents && this.props.bookingDetails.documents[0] &&
                    <BookingDetailsTopBar
                        documentId={this.props.bookingDetails.documentId}
                        incoTerm={this.props.bookingDetails.booking.incoterm}
                        bookingNumber={this.props.bookingDetails.booking.number}
                        shipmentId={this.props.bookingDetails.booking.shipmentId}
                        prepaidCollectIndicator={this.props.bookingDetails.documents[0].prepaidCollectIndicator}
                        originService={this.props.bookingDetails.documents[0].originService}
                        destinationService={this.props.bookingDetails.documents[0].destinationService}
                        placeOfReceiptCode={this.props.bookingDetails.documents[0].placeOfReceiptCode}
                        portOfLoadingCode={this.props.bookingDetails.documents[0].portOfLoadingCode}
                        portOfDischargeCode={this.props.bookingDetails.documents[0].portOfDischargeCode}
                        placeOfDeliveryCode={this.props.bookingDetails.documents[0].placeOfDeliveryCode}
                        isTriTrade={this.props.bookingDetails.booking.isTransferred ? 'Yes' : 'No'}
                        isActionHidden={true}
                    />}
                <div className="padding-left-large padding-right-large">
                    <TabComponent name="booking"
                        navLinks={navLinksBooking}
                        isDisabled={this.state.disableTab}
                        callbackFc={(e: number) => this.setState({ activeTab: e })}>
                        {!this.props.isNftpBillableLoading && !this.state.isNftpRoeEnabledLoading && this.props.bookingDetails.documentId && this.props.costAndrevenueresponse.result.length > 0 && <CostAndRevenue
                            targetType="origin"
                            showInvoices={false}
                            fStatus={this.props.bookingDetails.documents && this.props.bookingDetails.documents.length >= 1 && this.props.bookingDetails.documents[0].finOpsStatus ? [this.props.bookingDetails.documents[0].finOpsStatus] : ['']}
                            toggleTabs={(b: boolean) => this.setState({ disableTab: b })}
                            targetId={targetFunctionality.Booking}
                            partyData={{ country: this.props.bookingDetails.documents[0].documentIssuerCountryCode, company: this.props.bookingDetails.documents[0].companyCode, purchase: null }}
                            readOnly={this.props.bookingDetails.documents[0].originalDocumentNumber && this.props.bookingDetails.documents[0].originalDocumentNumber.indexOf('TMP') === -1 ? true : false}
                            outputCostRev={(cost: any[], revenue: any[]) => {
                                this.setState({ totalCost: clearFormat(calculateTotalOfField(cost, localCurrency.totalLocalCurrency)) });
                                this.setState({ totalRevenue: clearFormat(calculateTotalOfField(revenue, localCurrency.totalLocalCurrency)) });
                            }
                            }
                            costAndrevenueresponse={this.props.costAndrevenueresponse}
                            getCurrentPageMode={(mode) => this.setState({ isActionHidden: (mode === 'edit' || mode === 'add') ? true : false })}
                            eventCallback={() => this.setState({ showDialog: false, pendingError: '' })}
                            distributionData={generateDistributionData(this.props.bookingDetails)}
                            splitCols={CostColumnsData.getCostSubCols(isExtraDocumentFeatureEnabled)}
                            costAndRevenueId={Number(this.props.match.params.bookingId)}
                            docId={this.props.bookingDetails.documentId}
                            isNftpBillable = {this.props.isNftpBillable}
                            isNftpRoeEnabled = {this.state.isNftpRoeEnabled} />}
                        {this.props.bookingDetails.documents && this.props.bookingDetails.documents[0] &&
                            <BookingDetails
                                organisation={[
                                    { label: 'Company Code', value: formatValueIfNullOrUndefined(this.props.bookingDetails.documents[0].companyCode) },
                                    { label: 'Sales Area', value: formatValueIfNullOrUndefined(this.props.bookingDetails.documents[0].salesArea_Rev) },
                                    { label: 'Origin Office', value: `${formatValueIfNullOrUndefined(this.props.bookingDetails.booking.originSiteName)} (${formatValueIfNullOrUndefined(this.props.bookingDetails.booking.officeCode)})` },
                                    { label: 'Destination Office', value: `${formatValueIfNullOrUndefined(this.props.bookingDetails.booking.destinationSiteName)} (${formatValueIfNullOrUndefined(this.props.bookingDetails.booking.destinationSiteCode)})` }
                                ]}
                                locations={[
                                    { label: 'Place of receipt code', value: formatValueIfNullOrUndefined(this.props.bookingDetails.documents[0].placeOfReceiptCode) },
                                    { label: 'Port of loading code', value: formatValueIfNullOrUndefined(this.props.bookingDetails.documents[0].portOfLoadingCode) },
                                    { label: 'Port of discharge code', value: formatValueIfNullOrUndefined(this.props.bookingDetails.documents[0].portOfDischargeCode) },
                                    { label: 'Place of delivery code', value: formatValueIfNullOrUndefined(this.props.bookingDetails.documents[0].placeOfDeliveryCode) },
                                    { label: 'Place of receipt name', value: formatValueIfNullOrUndefined(this.props.bookingDetails.documents[0].placeOfReceiptName) },
                                    { label: 'Port of loading name', value: formatValueIfNullOrUndefined(this.props.bookingDetails.documents[0].portOfLoadingName) },
                                    { label: 'Port of discharge name', value: formatValueIfNullOrUndefined(this.props.bookingDetails.documents[0].portOfDischargeName) },
                                    { label: 'Place of delivery name', value: formatValueIfNullOrUndefined(this.props.bookingDetails.documents[0].placeOfDeliveryName) },
                                ]}
                                cargoDetails={[
                                    { label: 'Quantity', value: formatValueIfNullOrUndefined(this.props.bookingDetails.quantity) },
                                    { label: 'Package', value: formatValueIfNullOrUndefined(this.props.bookingDetails.packages) },
                                    { label: 'Volume', value: formatValueIfNullOrUndefined(clearFormat(this.props.bookingDetails.volume, 3)) },
                                    { label: 'Weight', value: formatValueIfNullOrUndefined(clearFormat(this.props.bookingDetails.weight, 3)) },
                                    { label: 'Special Cargo Indicator', value: formatValueIfNullOrUndefined(this.props.bookingDetails.booking.specialCargoIndicator) }
                                ]}
                                jobIdDetails={[
                                    {
                                        label: 'Export',
                                        value: this.getExportJobIdDetails().length > 0 ? this.getExportJobIdDetails() : formatValueIfNullOrUndefined('')
                                    },
                                    {
                                        label: 'Import',
                                        value: this.getImportJobIdDetails().length > 0 ? this.getImportJobIdDetails() : formatValueIfNullOrUndefined('')
                                    },
                                ]}
                                clr={{
                                    data: this.props.bookingDetails.clrs,
                                    cols: clrCols,
                                    name: 'cbl-details-clr'
                                }}
                                cbl={{ data: this.props.bookingDetails.cbLs, cols: cblCols, name: 'fcr-cbls-' }}
                                equipments={{ data: this.props.bookingDetails.equipments, cols: equipmentCols, name: 'fcr-billingDocuments-' }}
                                link={(url: string) => {
                                    this.props.history.push(url);
                                }}
                                fcr={{ data: this.props.bookingDetails.documents, cols: fcrCols(isExtraDocumentFeatureEnabled, true, isHblConsumptionEnabled), name: 'fcr-bookings-' }}
                                isExtraDocumentFeatureEnabled={isExtraDocumentFeatureEnabled}
                            />}
                        {this.props.bookingDetails.bookingId && this.state.activeTab === 3 && <Partners isVisible={this.state.activeTab === 3} target={1} targetId={this.props.bookingDetails.bookingId} />}
                        {this.props.bookingDetails.bookingId && this.state.activeTab === 4 && <HistoryLog shipmentId={this.props.match.params.bookingId.toString()} shipmentType={1} />}
                    </TabComponent>
                </div>
            </React.Fragment>
        );
    }
}
const mapStateToProps = (state: IStore): IMapStateToProps => ({
    bookingDetails: state.booking.bookingDetails,
    isFetchDataLoading: state.booking.isFetchBookingDataLoading || state.materialMaster.isFetchDataLoading,
    fetchError: state.booking.bookingDetailsPendingError,
    isFetchDataError: state.materialMaster.isFetchDataError,
    isFetchDataPendingError: state.materialMaster.isFetchDataPendingError,
    materialMasterList: state.materialMaster.materialMasterList,
    featureToggles: state.featureToggle.featureToggles,
    costAndrevenueresponse: state.costRevenue.response,
    isNftpBillable: state.exportJob.nftpBillableResponse?.isNftpBillable,
    isNftpBillableLoading: state.exportJob.isNftpBillableLoading
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    fetchBookingDetails: (bookingId: number) => dispatch(fetchBookingDetails(bookingId)),
    fetchCostAndRevenue: (type: number, valueId: any, targetType: string) => dispatch(fetchCostAndRevenue(type, valueId, targetType)),
    fetchNftpBillable: (jobId: number) => dispatch(fetchNftpBillable(jobId))
});

export const Charges = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_ChargesBookingDetails);
